import { IConfigSeller } from '@/models/configSeller'

// Define con qué componente se evalúa la batería:
// true  -> Discounts (flujo con % de salud, el de Apple)
// false -> SwitchBattery (flujo simple sobre/bajo 80%, el de Android)
// Si el seller no configura SBUS_BRAND_SWITCH_BATTERY se asume el flujo de Discounts.
export const canEvaluateBatteryWithSwitch = (configSeller: IConfigSeller, idSbu: number, brand: string): boolean => {
  const rules = configSeller.config.permisos.SBUS_BRAND_SWITCH_BATTERY
  if (rules === undefined) return true
  return rules.some(rule => rule.SBU === idSbu && rule.BRAND.includes(brand))
}
